<script setup lang="ts">
import type { VesselETA } from '~/models/vesselETA'
import { formatDate } from '~/utils'
import { VESSEL_SCHEDULE_LINKS_BY_TERMINAL } from '~/constants'
const props = defineProps<{
  eta: VesselETA
}>()

const link = computed((): string | null => {
  if (!props.eta.terminal) {
    return null
  }
  return VESSEL_SCHEDULE_LINKS_BY_TERMINAL.get(props.eta.terminal) ?? null
})

const formattedEtaDate = computed(() => formatDate(props.eta.eta))
</script>

<template>
  <component
    :is="link ? 'a' : 'span'"
    v-tooltip="{
      content: `This ETA is from the ${props.eta.portalLabel} vessel schedule.<br>VesselFinder or other sources may show different ETA,<br>but generally we find the terminal the most accurate<br>Click to view on ${props.eta.portalLabel}`,
      html: true,
    }"
    :href="link"
    :target="link ? '_blank' : undefined"
    class="text-gray-500"
    :class="{ 'hover:underline': link }"
  >
    ETA:
    <span class="text-gray-700">{{ formattedEtaDate }}</span>
    <span class="pl-1">({{ props.eta.portalLabel }})</span>
    <i-mdi:external-link v-if="link" class="align-middle ml-1" />
  </component>
</template>
